import { render } from "./homeAiInstructor.vue?vue&type=template&id=246bd879&scoped=true"
import script from "./homeAiInstructor.vue?vue&type=script&lang=js"
export * from "./homeAiInstructor.vue?vue&type=script&lang=js"

import "./homeAiInstructor.vue?vue&type=style&index=0&id=246bd879&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-246bd879"]])

export default __exports__